import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Grid_View.css";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";

import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useNavigate } from "react-router-dom";
import { encodeId, decodeId } from "../../../utils/common";
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import {
  getAllWishlist,
  postWishlist,
} from "../../../features/wishlist/wishlistSlice";
import { getAllCart } from "../../../features/cart/cartSlice";
import Login_Modal from "../common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common_modal/set_new_password_modal/Set_New_Password_Modal";
import Heart_icon from "../heart_icon/Heart_icon";
import Select_Product_Cart_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Cart_Modal";

const Product_Info_Grid_View = ({
  categoryId,
  setCategoryId,
  product,
  showQty,
}) => {
  const [favouriteProduct, setFavouriteProduct] = useState();
  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const [liked, setLiked] = useState(false);
  const [sparkle, setSparkle] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState({});
  const [variant, setVariant] = useState({});
  const isSignin = useSelector((state) => state.auth.is_signin);
  const allCart = useSelector((state) => state.cart.allCarts);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getAllCart(isSignin));
  // }, []);

  const toggleLike = () => {
    setLiked((prev) => !prev);

    if (!liked) {
      setSparkle(true);
      setTimeout(() => setSparkle(false), 800);
    }
  };

  const isIn = allCart?.data?.data?.some(
    (item) => item?.variant_id === selectedVariant?.id
  );

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);

  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  return (
    <section className="Product_Info_Grid_View_Section">
      <div className="Product_Info_Grid_View">
        <div
          className="upper_image_section"
          onClick={() => navigate(`/product-description/${encodeId(product?.id)}`)}
        >
          <div className="card_img_holder">
            <img
              className=""
              src={process.env.REACT_APP_IMG_URL + product?.image}
              alt={product?.product_name}
            />
          </div>

          {/* <div className="text_div">
            <div className="discont_div">
              <p className="discount_text">
                {Math.round(
                  ((product?.Product_Variants[0]?.mrp -
                    product?.Product_Variants[0]?.price) /
                    product?.Product_Variants[0]?.mrp) *
                  100
                )}
                % Off
              </p>
            </div>
          </div> */}

          <div className="overlay_text_holder">
            <div className="text_holder">
              <h5>{product?.Product_Variants[0]?.name}  {product?.Unit?.name}</h5>
            </div>
            <div className="text_holder">
              <p>{product?.Product_Variants[0]?.pieces}</p>
            </div>
          </div>
        </div>

        <div className="lower_text_section">
          <p
            className="product_name"
            onClick={() => navigate(`/product-description/${encodeId(product?.id)}`)}
          >
            {product?.name}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">
                 ₹{product?.Product_Variants[0]?.price}
              </p>
              <p className="mrp"> ₹{product?.Product_Variants[0]?.mrp}</p>
              {/* <div className='discount_div'>
                                <p className='discount'>{product?.discount}</p>
                            </div> */}
            </div>

           

            <div className="text-center btn_holder">
              {/* {!product?.outofStock ? ( */}
              <>
                {isIn ? (
                  <IncrementDecrementBtn
                    varientId={selectedVariant?.id}
                    cart={allCart?.data?.data}
                    productId={product?.id}
                    product={product}
                    isSignIn={isSignin}
                  />
                ) : (

                  <div className="">
                    <Green_Btn
                      btn_name="Add "
                      // leftIcon={faBasketShopping}
                      onClick={() => {
                        setShowIncrement(true);
                        Setaddcartmodal(true);
                      }}
                    />
                  </div>
                )}
              </>
              {/* ) : (
              <div className="">
                <Red_Outline_Btn btn_name="Out of Stock" />
              </div>
            )} */}
            </div>
          </div>

         
          <Heart_icon product={product} />


        </div>

        <Select_Product_Cart_Modal
          varient={product?.Product_Variants}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          product={product}
          show={addcartmodal}
          onHide={() => Setaddcartmodal(false)}
        />
      </div>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />
    </section>
  );
};

export default Product_Info_Grid_View;
